import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the dimensionByDivision state domain
 */

const selectDimensionByDivisionDomain = (state) =>
  state.get("dimensionByDivision", initialState)

/**
 * Other specific selectors
 */

export const makeSelectIsLoading = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectAmbassadorBenchmarkVisible = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("ambassadorBenchmarkVisible")
  )

export const makeSelectIsEngagement = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("isEngagement")
  )

export const makeSelectIsEngagementOnly = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("isEngagementOnly")
  )

export const makeSelectMeasureInfo = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("measureInfo")
  )

export const makeSelectDivisionsAvailable = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("divisionsAvailable")
  )

export const makeSelectDimensions = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("dimensions")
  )

export const makeSelectQuestions = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("questionList")
  )

export const makeSelectShowHistory = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("showHistory")
  )

export const makeSelectIfFirst = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("ifFirst")
  )

export const makeSelectShowDimensionBenchmark = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("showDimensionBenchmark")
  )

export const makeSelectSwitchMoreDimensions = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("switchMoreDimensions")
  )

export const makeSelectMetricTotal = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("metricTotal")
  )

export const makeSelectOutcomes = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("outcomes")
  )

/** RESTANTES POR IMPLEMENTAR */
export const makeSelectDivisions = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("divisions")
  )

export const makeSelectDivisionsTotal = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("divisionsTotal")
  )

export const makeSelectGraphicBars = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("graphicBars")
  )

export const makeSelectIsLoadingGraphicBars = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("isLoadingGraphicBars")
  )

export const makeSelectGraphicPeakons = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("graphicPeakon")
  )

export const makeSelectIsLoadingGraphicPeakon = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("isLoadingGraphicPeakon")
  )

export const makeSelectAmbassadors = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("ambassadors")
  )

export const makeSelectIsLoadingAmbassadors = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("isLoadingAmbassadors")
  )

export const makeSelectMeasureRangeColor = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("measureColorRange")
  )

export const makeSelectEvolutionData = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("evolutionData")
  )
export const makeSelectEvolutionLines = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("evolutionLines")
  )

export const makeEmployeesTotal = () =>
  createSelector(selectDimensionByDivisionDomain, (state) =>
    state.get("employeesTotal")
  )

/**
 * Default selector used by DimensionByDivision
 */

const makeSelectDimensionByDivision = () =>
  createSelector(selectDimensionByDivisionDomain, (substate) => substate.toJS())

export default makeSelectDimensionByDivision
export { selectDimensionByDivisionDomain }
